<template>
<v-container>
  <v-row align="center" justify="center" class="pt-6">
      <v-col cols="6">
        <p class="display-2 text-center font-weight-bold indigo--text">Performing Arts</p>
      </v-col>
    </v-row>
    <v-row align="center" justify="center">
      <v-col  v-for="(item, i) in subcategories.subCat" :key="i" :cols="size">
        <SUB   :category="item"/>
      </v-col>
    </v-row>
  
</v-container>
  
</template>

<script>
import SUB from "../../components/Landing/Subcategories.vue";
export default {
  props:[
    "subcategories"
  ],
  components: {
    SUB
  },
  data: () => ({
    size:4,
  })
};
</script>